import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Condition } from 'Component/others';
import useGetUserList from 'Domain/user/useGetUserList';
import TableComponent from 'UiKit/table-component';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import TableSkeleton from 'View/user/components/table-skeleton';
import { useUserState } from 'View/user/state';

import buildTableList from './const';
import styles from './styles.module.css';

const Table = () => {
  const { t } = useTranslation('user');
  const accessPermission = getMenuPermissions('master-data', 'user');
  const navigate = useNavigate();
  const { filterState, updateFilterState } = useUserState();
  const { data, isFetching } = useGetUserList({ queryParams: filterState });

  const onSort = (sort) => updateFilterState({ sort });
  const onChangePagination = (page) => updateFilterState({ page });

  const tableList = buildTableList(t);

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableSkeleton />}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            columns={tableList}
            isCanCreate={accessPermission?.isCanCreate}
            dataSource={data?.users}
            onSort={onSort}
            isScrollable={true}
            sortingData={filterState.sort}
            emptyActionText={t('createButton')}
            isDataExist={data?.isDataExist}
            onEmptyStateAction={() => navigate(`/master-data/user/upsert`)}
            onRowClick={(rowData) => navigate(`/master-data/user/upsert/${rowData.id}?viewType=read-only`)}
            maxTableHeight="calc(100vh - 293px)"
            maxTableBodyHeight="calc(100vh - 392px)"
            tableComponentHeight="calc(100vh - 221px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

const MemoizedTable = ({ ...props }) => useMemo(() => <Table {...props} /> /* eslint-disable */, []);

export default MemoizedTable;
